import { AssignedRenewalContactsState } from '@layout/renewal-contacts/store/states/assigned-renewal-contacts.state';
import { RenewalContactsState } from '@layout/renewal-contacts/store/states/renewal-contacts.state';

export const assignedRenewalContactsState = [AssignedRenewalContactsState, RenewalContactsState];
